import React, { Component } from 'react';
import styled from 'styled-components';
import Colors from '../Styles/Colors';

const Container = styled.div`
    background: ${Colors.black};
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding-top: 20px;
    padding-bottom: 20px;
    margin-bottom: 0;
`;

class HomePageWrapper extends Component {
  componentDidMount = () => {
  };

  render() {
    return (
      <Container>
          { this.props.children }
      </Container>
      
    );
  }
}

export default HomePageWrapper;
